import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../../app.constants';

@Injectable()
export class AuthService {
  private actionUrl: string;

  constructor(private http: HttpClient, private _configuration: Configuration) {
    this.actionUrl = _configuration.apiBase + 'auth/';
  }
  public getCurrentRole(): 'admin' | 'editor' {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match('(^|;)\\s*role\\s*=\\s*([^;]+)');
    return match
      ? (decodeURIComponent(match[2]) as 'admin' | 'editor')
      : 'admin';
  }
  public logout<T>(): Observable<T> {
    return this.http.get<T>(this.actionUrl + 'logout');
  }
}

@Injectable()
export class CustomInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.headers.has('Content-Type')) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json'),
      });
    }

    req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
    console.log(JSON.stringify(req.headers));
    return next.handle(req);
  }
}
